/* src/app/components/recommendation-modal/recommendation-modal.component.scss */
.button {
  width: 100%;
  padding: 18px;
  font-size: 18px;
  border-radius: 4px;
  border: 2px solid var(--ion-color-subway-yellow);
}
.button.filled {
  background: var(--ion-color-subway-yellow);
  color: var(--ion-color-subway-green-dark);
  transition: 0.3s linear;
}
.button.filled:hover {
  transition: 0.3s linear;
  background: var(--ion-color-subway-yellow-dark);
}
.button.flat {
  background: #ffffff;
  color: var(--ion-color-subway-yellow);
  transition: 0.3s linear;
}
.button.flat:hover {
  transition: 0.3s linear;
  background: darkgrey;
}
ion-icon {
  position: absolute;
  top: 16px;
  right: 16px;
}
/*# sourceMappingURL=recommendation-modal.component.css.map */
